import { Button, styled } from 'shared/Houston';

import { css } from '@eduzz/houston-styles/styled';

export const BackButton = styled(Button)`
  && {
    padding-left: 0;
    padding-right: 0;
    margin-bottom: ${({ theme }) => theme.spacing.xxs};
    color: ${({ theme }) => theme.neutralColor.low.medium};
    ${({ theme }) => css`
      @media only screen and (max-width: ${theme.breakpoints.md}) {
        margin-bottom: ${theme.spacing.stack.xxxs};
      }
    `}
  }
`;
